import type { IntegrationCompany } from '@web/data/repositories';
import { t } from '@web/i18n';

import { ChatToolCard } from './chat_tool_card';
import { CHAT_TOOLS, isBusy } from './integrations_shared';

export function CompanyDetail({
  company,
}: Readonly<{ company: IntegrationCompany }>): React.JSX.Element {
  return (
    <div className="flex flex-col gap-5">
      <header className="flex flex-col gap-1">
        <h2 className="m-0 text-section-title font-medium text-foreground">{company.name}</h2>
        <p className="m-0 text-meta text-muted-foreground">
          {company.companies.map((c) => c.name).join(' · ')}
        </p>
        <p className="m-0 text-meta text-muted-foreground">
          {t('integrations.detail.travelers', { count: company.travelerCount })}
          {company.emailDomains.length > 0
            ? t('integrations.detail.domains', { domains: company.emailDomains.join(', ') })
            : ''}
        </p>
      </header>
      <section className="flex flex-col gap-2.5">
        <h3 className="m-0 font-mono text-tiny font-medium uppercase tracking-eyebrow-wide text-muted-foreground">
          {t('integrations.detail.chatSection')}
        </h3>
        <p className="m-0 text-meta text-muted-foreground">{t('integrations.detail.chatRule')}</p>
        {CHAT_TOOLS.map((provider) => (
          <ChatToolCard
            key={provider}
            provider={provider}
            company={company}
            blockedBy={
              CHAT_TOOLS.find((other) => other !== provider && isBusy(company[other])) ?? null
            }
          />
        ))}
      </section>
    </div>
  );
}
